if (!customElements.get('legal-guarantee-dialog')) {
  customElements.define('legal-guarantee-dialog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const trigger = this.querySelector('[aria-haspopup="dialog"]');
      const dialog = this.querySelector('dialog');
      if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
      this.initialized = true;
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
      dialog.addEventListener('click', (event) => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) {
          dialog.close();
        }
      });
      dialog.addEventListener('close', () => {
        const returnFocus = this.returnFocus || trigger;
        if (returnFocus.isConnected) returnFocus.focus();
      });
    }
    open(trigger) {
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      this.returnFocus = trigger;
      if (!dialog.open) dialog.showModal();
      return true;
    }
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-legal-guarantee-open]');
    if (!trigger) return;
    const component = document.querySelector('legal-guarantee-dialog');
    if (component && component.open(trigger)) event.preventDefault();
  });
}
